module.exports = __webpack_public_path__ + "static/media/heart-white.18fe326d.svg";